import React, { useState } from "react";
import { toast } from "sonner";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Notify = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const validate = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate(email)) {
      toast.error("That email is more sour than our shirts. Try again.");
      return;
    }
    setSubmitting(true);
    try {
      const res = await axios.post(`${API}/notify`, { email });
      const msg = res?.data?.message || "Begging received.";
      toast.success(msg);
      setSubmitted(true);
      setEmail("");
    } catch (err) {
      // Visual-only flow — show a friendly message even on failure
      toast.success("Your beg has been filed in the drawer.");
      setSubmitted(true);
      setEmail("");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section
      id="notify"
      className="relative px-5 md:px-10 py-20 md:py-28 border-b-4 border-[#1C1914] bg-[#FFFDF5]"
      data-testid="notify-section"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-6">
          <p className="font-condensed text-lg uppercase tracking-widest text-[#D95D39]" data-testid="notify-eyebrow">
            // Drop 001 is loading (slowly)
          </p>
          <h2 className="font-display text-5xl md:text-7xl uppercase leading-none mt-3" data-testid="notify-title">
            Beg us to launch.
          </h2>
          <p className="mt-5 font-body text-lg md:text-xl max-w-lg text-[#1C1914]/80" data-testid="notify-description">
            Drop your email and we'll let you know the second four mediocre lemons hit our online store.
            No spam. Probably. We barely remember to email ourselves.
          </p>
        </div>

        <div className="lg:col-span-6">
          <form
            onSubmit={handleSubmit}
            noValidate
            className="border-4 border-[#1C1914] bg-[#FDE047] p-6 md:p-8 shadow-hard-lg relative"
            data-testid="notify-form"
          >
            <span className="sticker tape-rotate-2 absolute -top-4 -left-4" data-testid="notify-form-tag">
              waitlist
            </span>

            <label className="font-condensed text-xl uppercase tracking-widest block mb-3" htmlFor="notify-email">
              Your saddest email
            </label>
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                id="notify-email"
                type="email"
                placeholder="something@gmail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-duds bg-[#FFFDF5]"
                disabled={submitting}
                required
                data-testid="notify-email-input"
              />
              <button
                type="submit"
                className="btn-duds"
                disabled={submitting}
                data-testid="notify-submit-button"
              >
                {submitting ? "Filing…" : "Beg us"}
              </button>
            </div>

            <p className="mt-5 font-condensed text-sm uppercase tracking-widest text-[#1C1914]/70">
              By submitting you agree to receive ~3 emails per decade.
            </p>

            {submitted && (
              <div className="mt-6 border-t-2 border-dashed border-[#1C1914] pt-4 font-body text-base text-[#1C1914]" data-testid="notify-success-message">
                Filed. We'll bother you when the lemons are ready.
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Notify;
